var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3B4652;}\r\n\t.st1{fill:#2B79C2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M327.2,187.5c0-41.6-33.7-75.3-75.3-75.3c-4.6,0-9.1,0.4-13.4,1.2c2.9-7.1,4.5-14.9,4.5-23   c0-33.5-27.2-60.7-60.7-60.7c-29.6,0-54.2,21.1-59.6,49.1c-0.4,0-0.7,0-1.1,0c-50.8,0-92.1,41.2-92.1,92.1s41.2,92.1,92.1,92.1   c27.6,0,105.1,0,130.3,0C293.5,262.8,327.2,229.1,327.2,187.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.5,330.6c0,19,15.5,34.5,34.5,34.5c19,0,34.5-15.5,34.5-34.5c0-19-15.5-34.5-34.5-34.5   C143.9,296.1,128.5,311.6,128.5,330.6z M183.5,330.6c0,11.3-9.2,20.5-20.5,20.5c-11.3,0-20.5-9.2-20.5-20.5s9.2-20.5,20.5-20.5   C174.3,310.1,183.5,319.3,183.5,330.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M287,307.1c-13,0-23.5,10.5-23.5,23.5s10.5,23.5,23.5,23.5c13,0,23.5-10.5,23.5-23.5S299.9,307.1,287,307.1z    M287,340.1c-5.2,0-9.5-4.3-9.5-9.5c0-5.2,4.3-9.5,9.5-9.5c5.2,0,9.5,4.3,9.5,9.5C296.5,335.9,292.2,340.1,287,340.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.9,359.3c-19,0-34.5,15.5-34.5,34.5s15.5,34.5,34.5,34.5c19,0,34.5-15.5,34.5-34.5   S378.9,359.3,359.9,359.3z M359.9,414.3c-11.3,0-20.5-9.2-20.5-20.5c0-11.3,9.2-20.5,20.5-20.5s20.5,9.2,20.5,20.5   C380.4,405.1,371.2,414.3,359.9,414.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.6,278.9c19,0,34.5-15.5,34.5-34.5c0-19-15.5-34.5-34.5-34.5c-19,0-34.5,15.5-34.5,34.5   C361.1,263.4,376.6,278.9,395.6,278.9z M395.6,223.9c11.3,0,20.5,9.2,20.5,20.5c0,11.3-9.2,20.5-20.5,20.5s-20.5-9.2-20.5-20.5   C375.1,233,384.3,223.9,395.6,223.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.9,89.9c3.6,2.7,8,4.1,12.4,4.1c1,0,2.1-0.1,3.1-0.2c5.5-0.8,10.4-3.7,13.7-8.2c3.3-4.5,4.7-10,3.9-15.5v0   c-1.7-11.4-12.4-19.3-23.8-17.6c-11.4,1.7-19.3,12.4-17.6,23.8C277.5,81.7,280.4,86.6,284.9,89.9z M296.4,66.2   c0.3-0.1,0.7-0.1,1-0.1c3.4,0,6.3,2.5,6.9,5.9v0c0.3,1.8-0.2,3.7-1.3,5.1c-1.1,1.5-2.7,2.5-4.6,2.7c-1.8,0.3-3.7-0.2-5.1-1.3   c-1.5-1.1-2.5-2.7-2.7-4.6C290,70.3,292.6,66.8,296.4,66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M456,278.3c-14.6,0-26.4,11.9-26.4,26.4s11.9,26.4,26.4,26.4c14.6,0,26.4-11.9,26.4-26.4   S470.6,278.3,456,278.3z M456,317.2c-6.9,0-12.4-5.6-12.4-12.4s5.6-12.4,12.4-12.4c6.9,0,12.4,5.6,12.4,12.4S462.9,317.2,456,317.2   z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M249.7,382.9c-19,0-34.5,15.5-34.5,34.5c0,19,15.5,34.5,34.5,34.5c19,0,34.5-15.5,34.5-34.5   C284.2,398.4,268.8,382.9,249.7,382.9z M249.7,437.9c-11.3,0-20.5-9.2-20.5-20.5c0-11.3,9.2-20.5,20.5-20.5   c11.3,0,20.5,9.2,20.5,20.5C270.2,428.7,261.1,437.9,249.7,437.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.4,184.4c1.4,1.4,3.2,2.1,5,2.1s3.6-0.7,5-2.1c2.7-2.7,2.7-7.2,0-9.9l-37.7-37.7c-2.7-2.7-7.2-2.7-9.9,0   c-2.7,2.7-2.7,7.2,0,9.9L411.4,184.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M440.7,213.1c1.4,1.4,3.2,2.1,5,2.1c1.8,0,3.6-0.7,5-2.1c2.7-2.7,2.7-7.2,0-9.9l-9.1-9.1   c-2.7-2.7-7.2-2.7-9.9,0c-2.7,2.7-2.7,7.2,0,9.9L440.7,213.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429.2,365.8c2.7-2.7,2.7-7.2,0-9.9l-55.3-55.3c-2.7-2.7-7.2-2.7-9.9,0c-2.7,2.7-2.7,7.2,0,9.9l55.3,55.3   c1.4,1.4,3.2,2,5,2C426.1,367.9,427.9,367.2,429.2,365.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M458.2,384.2c-2.7-2.7-7.2-2.7-9.9,0c-2.7,2.7-2.7,7.2,0,9.9l14,14c1.4,1.4,3.2,2,5,2c1.8,0,3.6-0.7,5-2   c2.7-2.7,2.7-7.2,0-9.9L458.2,384.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M140.4,397.2c-2.7-2.7-7.2-2.7-9.9,0c-2.7,2.7-2.7,7.2,0,9.9l69.6,69.6c1.4,1.4,3.2,2,5,2c1.8,0,3.6-0.7,5-2   c2.7-2.7,2.7-7.2,0-9.9L140.4,397.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.2,441c-2.7-2.7-7.2-2.7-9.9,0c-2.7,2.7-2.7,7.2,0,9.9l17.1,17.1c1.4,1.4,3.2,2,5,2c1.8,0,3.6-0.7,5-2   c2.7-2.7,2.7-7.2,0-9.9L332.2,441z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.9,449.5c-2.7-2.7-7.2-2.7-9.9,0c-2.7,2.7-2.7,7.2,0,9.9l21,21c1.4,1.4,3.2,2.1,5,2.1c1.8,0,3.6-0.7,4.9-2   c2.7-2.7,2.7-7.2,0-9.9L434.9,449.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRain);
export default __webpack_public_path__ + "static/media/rain.34c7041ac40e037fbfed3a4d12fdb89b.svg";
export { ForwardRef as ReactComponent };